module.exports = __webpack_public_path__ + "img/spins_5.b3674608.png";